import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=83f460aa&scoped=true&"
import script from "./PlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=83f460aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f460aa",
  null
  
)

export default component.exports